<template>
    <div class="table_responsive">
        <table class="table">
            <thead>
                <tr>
                    <th v-for="(col, index) in columns"
                        :key="index"
                        @click="sorting(col)"
                        :style="{ width: col.width ? col.width : 'auto' }">
                        <div v-if="col.headerSlot">
                            <slot :name="col.headerSlotName"></slot>
                        </div>
                        <div v-else>
                            {{ col.label }}
                            <div class="data_table_arrow" :class="[{'arrow_down': col.sortable && sortColumn === col.field && sortOrder === 'asc'}, {'arrow_up': col.sortable && sortColumn === col.field && sortOrder === 'desc'}]" v-if="col.sortable"></div>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="loader">
                <tr>
                  <td colspan="11">
                    <div class="preloader_ico">
                    <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <button class="btn btn_blue mr_10">Picklist</button>
                    <button class="btn btn_blue">Print Invoice</button>
                  </td>
                  <td colspan="9"><b>$ 0.00</b></td>
                </tr>
            </tbody>
            <tbody v-else>
                <template v-if="rows.length > 0">
                    <tr v-for="(row, i) in rows" :key="i">
                        <td v-for="(col, j) in columns" :key="j" @click.prevent="col.click ? col.click(row) : false">
                            <div v-if="col.display" v-html="col.display(row)"></div>
                            <div v-else-if="col.slot">
                                <slot :row="row" :index="i" :name="col.field"></slot>
                            </div>
                            <template v-else>
                                <span>{{ col.field.split('.').length > 1 ? (row[col.field.split('.')[0]] !== null ? row[col.field.split('.')[0]][col.field.split('.')[1]] : '') : row[col.field] }}</span>
                            </template>
                        </td>
                    </tr>
                </template>
                <template v-else>
                    <tr>
                        <td :colspan="columns.length" class="text_center">
                            <span class="font_italic color_grey_type2">You currently have 0 items.</span>
                        </td>
                    </tr>
                </template>

                <slot :name="'footer'"></slot>
            </tbody>
        </table>
    </div>

    <pagination-component :pagination="pagination" @changePage="changePage"></pagination-component>
</template>

<script>
import PaginationComponent from "@/components/shared/PaginationComponent";

export default {
    name: "TableComponent",
    components: {PaginationComponent},
    emits: ['pageChanged', 'sorting'],
    props: {
        isLoading: {
            type: Boolean,
            require: true,
        },
        pagination: {
            type: Object,
            required: false,
        },
        loader: {
            type: Boolean,
            required: false,
        },
        columns: {
            type: Array,
            default: () => {
                return [];
            },
        },
        footer: {
            type: Array,
            default: () => {
                return [];
            },
        },
        rows: {
            type: Array,
            default: () => {
                return [];
            },
        },
        sortable: {
            type: Object,
            default: () => {
                return {
                    order: "id",
                    sort: "asc",
                };
            },
        },
    },
    data() {
        return {
            sortColumn: this.sortable.order,
            sortOrder: this.sortable.sort
        }
    },
    methods: {
        sorting(column) {
            if (column.sortable) {
                if (column.field === this.sortColumn)
                    this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
                else {
                    this.sortOrder = 'asc';
                }

                this.sortColumn = column.field;
                this.$emit('sorting', {column: this.sortColumn, order: this.sortOrder});
            }
        },
        changePage(page) {
            this.$emit('pageChanged', page);
        }
    }
}
</script>

<style>
.text_center {
  text-align: center !important;
}
.preloader_ico{
  text-align: center;
  min-height: 10px;
  vertical-align: middle;
}
 .preloader_ico i{
  line-height: 10px;
  font-size: 20px;
  color: #999
}
</style>